import styled from 'styled-components'

import { theme } from '@/styles/theme'

import type { BlogInterviewee } from '@/types/blog'

type Props = BlogInterviewee

export const Interviewee = ({ profileImage, fullName, biography }: Props) => {
  return (
    <Content>
      <Image src={profileImage.src} width="44px" height="44px" alt={fullName} />
      <div>
        <EditorName>{fullName}</EditorName>
        <EditorPosition>{biography}</EditorPosition>
      </div>
    </Content>
  )
}

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
`

const Image = styled.img`
  border-radius: 50%;
`

const EditorName = styled.div`
  font-size: 15px;
  line-height: 17px;
  letter-spacing: 1.5px;
  color: ${theme.colors.textTitle};
  margin-bottom: 2px;
`

const EditorPosition = styled.div`
  font-size: 11px;
  line-height: 15px;
  letter-spacing: 1.1px;
  color: ${theme.colors.textSecond};
`
